import classnames from 'classnames'
import { css } from 'emotion'
import { Product, TrackingKey } from 'even-ts-static'
import { filter } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'

import { CommonState } from 'embed/reducers'
import { ApplicationFields, Field } from 'embed/constants'
import { loanApplicationFieldsSelector, summaryFieldsToDisplay } from 'embed/selectors/application'
import Tracker from 'common/services/Tracker'
import { Fields } from 'embed/constants/fields'

import { ApplicationField } from 'embed/components/ApplicationField/container'
import ThemeConsumer from 'embed/components/ThemeConsumer'

import ReadOnlyField from './ReadOnlyField'

const styles = require('./styles')

export interface Props {
  fieldsData: ApplicationFields
  fieldsToDisplay: Field[]
}

const AddressFields = [Fields.AddressOne, Fields.AddressTwo, Fields.Zipcode, Fields.City, Fields.State]

const SummaryCard = ({ fieldsData, fieldsToDisplay }: Props) => {
  const [isEditing, setIsEditing] = React.useState(false)

  const enableEditing = () => {
    setIsEditing(true)
    Tracker.trackEvent({
      action: TrackingKey.PlaidEditSummaryCard,
      data: { isEditing: true },
      timestamp: new Date(),
    })
  }

  return fieldsToDisplay.length > 0 ? (
    <div className={styles.container}>
      <div className={classnames(styles.fieldsContainer, isEditing ? styles.isEditing : styles.isNotEditing)}>
        {isEditing ? (
          <>
            {fieldsToDisplay.map((field) => (
              <ApplicationField key={field.key} product={Product.Loan} field={field} />
            ))}
          </>
        ) : (
          <>
            <section>
              {filter(fieldsToDisplay, (field) => !AddressFields.includes(field)).map((field) => (
                <ReadOnlyField key={field.key} field={field} value={fieldsData[field.key]?.value} />
              ))}
            </section>
            <section>
              {filter(fieldsToDisplay, (field) => AddressFields.includes(field)).map((field) => (
                <ReadOnlyField key={field.key} field={field} value={fieldsData[field.key]?.value} />
              ))}
            </section>
          </>
        )}
      </div>
      {!isEditing && (
        <ThemeConsumer>
          {({ borderRadiusSmall, colorBorder, colorPrimary }) => (
            <div
              className={classnames(
                styles.editButton,
                css`
                  border-color: ${colorBorder};
                  border-radius: ${borderRadiusSmall};
                  color: ${colorPrimary};
                `,
              )}
              onClick={enableEditing}
            >
              Edit Details
            </div>
          )}
        </ThemeConsumer>
      )}
    </div>
  ) : null
}

const mapStateToProps = (state: CommonState) => ({
  fieldsData: loanApplicationFieldsSelector(state),
  fieldsToDisplay: summaryFieldsToDisplay(state),
})

export default connect(mapStateToProps)(SummaryCard)
